import { render, staticRenderFns } from "./ManagementDetail.vue?vue&type=template&id=cd32c384&scoped=true&"
import script from "./ManagementDetail.vue?vue&type=script&lang=js&"
export * from "./ManagementDetail.vue?vue&type=script&lang=js&"
import style0 from "./ManagementDetail.vue?vue&type=style&index=0&id=cd32c384&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd32c384",
  null
  
)

export default component.exports